import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiSwitch from '@mui/material/Switch';
import * as React from 'react';
import { FlexBox } from '../box';
import { useId } from '../hooks';
import { styled } from '../styled';
import { FieldSkeleton } from '../textfield/utils';
import { sentence, Typography } from '../typography';
import { withVersion } from '../utils';
const SwitchRoot = styled(FlexBox)({});
const SwitchImpl = (props) => {
    const { label, description, checked, disabled, error, skeleton = false, onChange, className, 'data-testid': dataTestId, 'data-role': dataRole, 'data-role-value': dataRoleValue, 'aria-label': ariaLabel } = props;
    const switchId = useId();
    const handleChange = (e) => {
        if (!disabled) {
            onChange?.(e.target.checked, e);
        }
    };
    const content = (_jsxs(SwitchRoot, { vAlign: "center", className: className, "data-role": dataRole ?? 'switch', "data-role-value": dataRoleValue, children: [_jsx(MuiSwitch, { checked: checked, disabled: disabled, onChange: handleChange, "data-testid": dataTestId, slotProps: {
                    input: {
                        role: 'switch',
                        'aria-labelledby': label ? switchId : undefined,
                        'aria-label': label ? undefined : ariaLabel
                    }
                } }), label && (_jsxs(FlexBox, { flexDirection: "column", children: [_jsx(Typography, { color: "text.primary", id: switchId, children: sentence(label) }), description && (_jsx(Typography, { color: "text.secondary", gutterBottom: true, children: sentence(description) })), error && (_jsx(Typography, { variant: "detail", color: "error", children: sentence(error) }))] }))] }));
    if (skeleton) {
        return _jsx(FieldSkeleton, { width: "fit-content", children: content });
    }
    return content;
};
export const Switch = withVersion(SwitchImpl, '1.0.0');
